
namespace TabAurous.ProductDevelopment {

    
    @Serenity.Decorators.registerClass()
    export class CustomerRequirementSelectGrid extends _Ext.GridBase<CustomerRequirementItemsRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.CustomerRequirementItems'; }
        protected getDialogType() { return CustomerRequirementItemsDialog; }
        protected getIdProperty() { return CustomerRequirementItemsRow.idProperty; }
        protected getInsertPermission() { return CustomerRequirementItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return CustomerRequirementItemsRow.localTextPrefix; }
        protected getService() { return CustomerRequirementItemsService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {};
        public rowSelection: Serenity.GridRowSelectionMixin; 
    

        constructor(container: JQuery, options) {
            super(container, options);
             
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): SalesOrder.SalesOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }




        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}